import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';
import { Role } from '../utils/Enums/Roles';
import { Spinner } from 'react-bootstrap';

export const AccessibilityCheckRoute = ({ allowedRoles, forbiddenRoles }: { allowedRoles: Role[], forbiddenRoles?: Role[] }): JSX.Element => {
    const { hasPermission, loading } = useContext(AuthContext);

    if (forbiddenRoles && hasPermission(forbiddenRoles)) {
        return <Navigate to='/no-access' replace />;
    }

    if (hasPermission(allowedRoles)) {
        return (
            <>
                <Outlet />
            </>
        );
    }

    if (loading) {
        return (
            <div className='d-flex justify-content-center align-items-center vh-100 w-100'>
                <Spinner animation='border' variant='primary' />
            </div>
        );
    }

    return <Navigate to='/no-access' replace />;
};

